












































































































































































































































































import { Vue, Component, Watch } from "vue-property-decorator";
import { Action, Getter, Mutation } from "vuex-class";
import {
  IBudget,
  ICompetitor,
  ICoupon,
  ICouponMessage,
  IStoreCoupon,
} from "../vuex/modules/coupon/interfaces";
import DialogCoupon from "./DialogCoupon.vue";
import FormCompetitor from "./FormCompetitor.vue";

@Component({
  components: {
    DialogCoupon,
    FormCompetitor,
  },
})
export default class FormCoupon extends Vue {
  @Getter("getBudget", { namespace: "coupon" }) budget!: IBudget;
  @Getter("getCompetitor", { namespace: "coupon" }) competitor!: ICompetitor;
  @Getter("getExistCoupon", { namespace: "coupon" }) existCoupon!: boolean;
  @Getter("getTypesCoupon", { namespace: "coupon" }) typesCoupon!: string[];

  @Mutation("setBudget", { namespace: "coupon" }) setBudget!: (
    parmas: IBudget
  ) => void;

  @Mutation("setCompetitor", { namespace: "coupon" }) setCompetitor!: (
    parmas: ICompetitor
  ) => void;

  @Mutation("setExistCoupon", { namespace: "coupon" }) setExistCoupon!: (
    param: boolean
  ) => void;

  @Action("loadBudget", { namespace: "coupon" })
  loadBudget!: (idBudget: string) => Promise<IBudget>;

  @Action("storeCoupon", { namespace: "coupon" }) storeCoupon!: (
    coupon: ICoupon
  ) => Promise<boolean>;

  coverDiscount = 0;
  valueRoof = 0;

  typesPayment = [
    "Cartão de Crédito",
    "Pix",
    "Boleto",
    "Financiamento",
    // "Múltiplos",
  ];
  showBanck = false
  financing =""
  banks = [
    {
      name:'Banco do Brasil',
      value:'Financiamento/Banco do Brasil'
    },
    {
      name:'Sol Fácil',
      value:'Financiamento/Sol Fácil'
    },
    {
      name:'Losango',
      value:'Financiamento/Losango',
    },
    {
      name:'BV Financeira',
      value:'Financiamento/BV Financeira',
    },
  ];

  coupon: ICoupon = {
    budgetValue: 0,
    description: "",
    nameCoupon: "",
    codeCoupon: "",
    couponValueBrl: 0,
    couponTotalValueBrl: 0,
    typeCoupon: "",
    competitionName: "",
    validCoupon: true,
    discountPerCent: "",
    typePayment: "",
  };

  dialog = false;
  couponMessage: ICouponMessage = {
    title: "",
    body: "",
  };
  overlay = false;
  validateCoupon = false;
  validDiscountValue = false;
  switchTypeValue = false;
  //eslint-disable-next-line
  discountValue: any = 0;

  @Watch("coupon.typePayment")
  onCouponTypePaymentChange(value: string, old: string): void {
    if (value == "Financiamento") {
      this.showBanck = true
    }else{
      this.showBanck = false
      this.financing = ""
    }
  }

  @Watch("coupon.typeCoupon")
  onCouponTypeCouponChange(value: string, old: string): void {
    if (old == "Bater Concorrência") {
      const competitor: ICompetitor = {
        name: "",
        typeStructure: "",
        brandInverter: "",
        powerInverter: "",
        amountInverter: "",
        powerPanel: "",
        brandPanel: "",
        amountPanel: "",
        powerSystem: 0,
        valueBudget: "",
        wattValue: 0,
        offer: "",
        pdfCompetitor: null,
        coverDiscount: 0,
        valueRoof: 0,
      };
      this.setCompetitor(competitor);
    }
  }
  @Watch("switchTypeValue")
  onSwitchTypeValueChange(value: boolean): void {
    if (isNaN(this.discountValue)) {
      this.discountValue = 0;
    }
    if (value) {
      this.discountValue = this.coupon.couponValueBrl;
    } else {
      this.discountValue = (
        (this.discountValue * 100) /
        this.budget.value
      ).toFixed(4);
    }
  }

  @Watch("discountValue")
  onDiscountValueChange(): void {
    if (isNaN(this.discountValue)) {
      return;
    }

    if (parseFloat(this.discountValue) > 100 && !this.switchTypeValue) {
      this.discountValue = 100;
    }
    if (!this.switchTypeValue) {
      this.coupon.couponValueBrl = parseFloat(
        (
          (this.discountValue * this.budget.discountMaxBrl) /
          this.budget.discountMaxPercent
        ).toFixed(2)
      );
      this.coupon.discountPerCent = this.discountValue;
    } else {
      this.coupon.discountPerCent = (
        (this.discountValue * 100) /
        this.budget.equipamentValue
      ).toFixed(4);
      this.coupon.couponValueBrl = parseFloat(this.discountValue);
    }

    if (isNaN(this.coupon.couponValueBrl)) {
      this.coupon.couponValueBrl = 0;
    }

    if (this.coupon.couponValueBrl > this.budget.discountMaxBrl) {
      this.validDiscountValue = true;
    } else {
      this.validDiscountValue = false;
    }
  }

  public coverValue(): void {
    if (this.competitor.offer <= this.competitor.valueBudget) {
      if (
        this.budget.discountsActive >
        this.budget.equipamentValue - this.competitor.valueRoof
      ) {
        this.competitor.coverDiscount = 0;
      } else {
        this.competitor.coverDiscount =
          this.budget.equipamentValue -
          this.competitor.valueRoof -
          this.budget.discountsActive;
      }
    } else {
      if (
        this.budget.discountsActive >
        this.budget.equipamentValue - this.competitor.offer
      ) {
        this.competitor.coverDiscount = 0;
      } else {
        this.competitor.coverDiscount =
          this.budget.equipamentValue -
          this.competitor.offer -
          this.budget.discountsActive;
      }
    }
  }

  public plusUseCoupon(index: number): void {
    if (
      !(
        this.budget.couponsActive[index].use >=
        this.budget.couponsActive[index].maxUse
      )
    ) {
      this.budget.couponsActive[index].use += 1;
      this.budget.discountsActive += this.budget.couponsActive[index].value;
    }
  }

  public minusUseCoupon(index: number): void {
    if (!(this.budget.couponsActive[index].use <= 0)) {
      this.budget.couponsActive[index].use -= 1;
      this.budget.discountsActive -= this.budget.couponsActive[index].value;
    }
  }

  public closeDialog(): void {
    this.dialog = false;
  }

  public generateCoupon(): void {
    if (
        this.coupon.description != "" &&
        this.coupon.nameCoupon != "" &&
        this.coupon.couponValueBrl > 0 &&
        this.coupon.typeCoupon != "" &&
        this.coupon.typePayment != "" &&
        !(
          this.coupon.typeCoupon == "Bater Concorrência" &&
          (this.competitor.name == "" ||
            this.budget.powerInverter == "" ||
            this.budget.powerPanel == "" ||
            this.competitor.brandInverter == "" ||
            this.competitor.powerInverter == "" ||
            this.competitor.amountInverter == "" ||
            this.competitor.amountPanel == "" ||
            this.competitor.powerPanel == "" ||
            this.competitor.brandPanel == "" ||
            this.competitor.powerSystem == 0 ||
            this.competitor.wattValue == 0 ||
            this.competitor.pdfCompetitor == ""||
            this.competitor.pdfCompetitor == null)
        )
      ) {
      if(this.coupon.typePayment == 'Financiamento'){
        if(this.financing !=''){
          this.coupon.typePayment = this.financing
        }else{
           this.couponMessage = {
              title: "Ops!",
              body: "Informe o banco do financiamento",
            };
             this.validateCoupon = false;
            this.dialog = true;
            return
        }
      }
      if (this.coupon.typePayment == 'Cartão de Crédito') {
         this.couponMessage = {
              title: "Ops!",
              body: "Forma de pagamento não disponível para geração de cupom. Verifique as possibilidades com seu supervisor.",
            };
             this.validateCoupon = false;
            this.dialog = true;
            return
      }
      this.coupon.budgetValue = this.budget.value;
      this.coupon.validCoupon = !this.validDiscountValue;
      if (this.coupon.typeCoupon == "Ajuste de Valor") {
        this.coupon.validCoupon = false;
      }
      this.coupon.couponTotalValueBrl = this.budget.discountsActive + this.coupon.couponValueBrl ;
      const codeConsultant = this.budget.consultantName
        .substr(0, 3)
        .toUpperCase();
      this.coupon.codeCoupon = String(this.budget.id) + codeConsultant;
      this.overlay = true;
      const newCoupon: IStoreCoupon = {
        coupon: this.coupon,
        competitor: this.competitor,
      };
      this.storeCoupon(newCoupon.coupon).then((response) => {
        if (response) {
          if (!this.validDiscountValue) {
            this.couponMessage = {
              title: "Sucesso!",
              body: "Seu cupom foi criado com sucesso! Você já pode acompanhar ele disponível em nossa lista",
            };
          } else {
            this.couponMessage = {
              title: "Atenção!",
              body: "Você solicitou um valor de desconto superior ao permitido. Entre em contato com seu supervisor",
            };
          }
          this.validateCoupon = true;
          this.discountValue = "0";
          this.coupon = {
            typePayment: "",
            budgetValue: 0,
            description: "",
            nameCoupon: "",
            codeCoupon: "",
            couponValueBrl: 0,
            couponTotalValueBrl: 0,
            typeCoupon: "",
            competitionName: "",
            validCoupon: true,
            discountPerCent: "",
          };
          this.setExistCoupon(true);

          const competitor: ICompetitor = {
            name: "",
            typeStructure: "",
            brandInverter: "",
            powerInverter: "",
            amountInverter: "",
            powerPanel: "",
            brandPanel: "",
            amountPanel: "",
            powerSystem: 0,
            valueBudget: "",
            wattValue: 0,
            offer: "",
            pdfCompetitor: null,
            coverDiscount: 0,
            valueRoof: 0,
          };
          this.setCompetitor(competitor);
          const params: IBudget = {
            generators: [],
            id: "",
            transferValue: 0,
            equipamentValue: 0,
            couponsActive: [],
            discountsActive: 0,
            idIntegrator: 0,
            value: 0.0,
            discountMaxBrl: 0,
            discountMaxPercent: 0,
            consultantName: "Nome do Consultor",
            integratorName: "Nome do Integrador",
            fantasyIntegratorName: "Nome Fantasia",
            reasonIntegratorName: "Razão Social",
            amountInverters: 0,
            powerInverter: 0,
            brandInverter: "Marca do inversor",
            brandPanel: "Marda do painel",
            powerPanel: 0,
            amountPanel: 0,
            powerSystem: 0,
            typeStructure: "Estrutura",
            deliveryLocale: "Local de entrega",
            totalDiscount: 0,
            inGroup: false,
          };
          this.setBudget(params);
        } else {
          this.couponMessage = {
            title: "Erro!",
            body: "Já existe um cupom para este orçamento",
          };
        }
        this.overlay = false;
        this.dialog = true;
      });
    } else {
      this.couponMessage = {
        title: "Erro!",
        body: " Preencha todos os campos para gerar o cupom!",
      };
      this.validateCoupon = false;
      this.dialog = true;
    }
  }

  public formatDiscount(): void {
    const stringDiscount = this.discountValue.toString();
    this.discountValue = stringDiscount.replace(
      /[a-zA-Z\u00C0-\u00FF!@#+$%¨&*()/{}[/\]|`´^~;:?ªº§=°', "]+/i,
      ""
    );
  }
}
